import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Config } from "constant";
import Modal from "module-common/Modal";
import Button from "module-common/Button";
import Input from "module-common/Input";
import { ShowNotice } from "Store";
import { graphql, compose } from "react-apollo";
import {
  mutationWhatsappRegistration,
  mutationWhatsappCodeConfirmation
} from "Apollo";
import { Select } from "antd";
import { whatsappRegistrationList } from "../../constant";

const Option = Select.Option;
export default compose(
  graphql(mutationWhatsappRegistration, {
    name: "whatsappRegistration"
  }),
  graphql(mutationWhatsappCodeConfirmation, {
    name: "whatsappConfirmationCode"
  })
)(
  class ConfirmModal extends Component {
    static propTypes = {
      text: PropTypes.string,
      onCancel: PropTypes.func,
      onConfirm: PropTypes.func,
      isConfirmLoading: PropTypes.bool
    };

    state = {
      phoneNumber: "62",
      country: "indonesia",
      provider: "psn",
      confirmationCode: "",
      onRegistration: true
    };

    changeCountryToMcc = item => {
      this.setState({
        country: item
      });
    };

    changeProviderToMnc = item => {
      this.setState({
        provider: item
      });
    };

    render() {
      const { text, onCancel, isConfirmLoading } = this.props;
      const {
        phoneNumber,
        country,
        provider,
        confirmationCode,
        onRegistration,
        name
      } = this.state;

      return (
        <Modal>
          {onRegistration ? (
            <Wrapper>
              <Text>{text}</Text>
              <Label>Phone Number</Label>
              <Input
                label="Phone Numbers"
                name="phone_number"
                value={phoneNumber}
                type="number"
                onChange={e => this.setState({ phoneNumber: e.target.value })}
              />

              <Label>Country</Label>
              <Select
                defaultValue="indonesia"
                style={{ width: 200 }}
                onChange={item => this.changeCountryToMcc(item)}
              >
                <Option value="indonesia">Indonesia</Option>
              </Select>

              <Label>Provider</Label>
              <Select
                defaultValue="psn"
                style={{ width: 200 }}
                onChange={item => this.changeProviderToMnc(item)}
              >
                <Option value="psn">PSN</Option>
                <Option value="indosatooredoo">Indosat Ooredoo</Option>
                <Option value="starone">StarOne</Option>
                <Option value="telkomflexi">Telkom Flexi</Option>
                <Option value="axis">Axis</Option>
                <Option value="smartfren">Smartfren</Option>
                <Option value="telkomsel">Telkomsel</Option>
                <Option value="xl">XL</Option>
                <Option value="telkommobile">Telkom Mobile</Option>
                <Option value="im3">IM3</Option>
                <Option value="net1">Net1</Option>
                <Option value="fren">Fren</Option>
                <Option value="bolt!super4G">BOLT! Super 4G</Option>
                <Option value="3">3</Option>
                <Option value="esia">Esia</Option>
              </Select>

              <Buttons>
                <Button
                  width={80}
                  onClick={onCancel}
                  color="gray"
                  disabled={isConfirmLoading}
                >
                  Cancel
                </Button>

                <Button
                  width={90}
                  onClick={this.onRegistration}
                  loading={isConfirmLoading}
                  disabled={isConfirmLoading}
                >
                  Registration
                </Button>
              </Buttons>
            </Wrapper>
          ) : (
            <Wrapper>
              <Text>{text}</Text>
              <Label>Phone Number</Label>
              <Input
                label="Phonenumber"
                name="phone_number"
                value={phoneNumber}
                type="text"
                disabled={true}
              />
              <Label>Contact Name</Label>
              <Input
                label="Name"
                name="name"
                value={name}
                type="text"
                onChange={e => this.setState({ name: e.target.value })}
              />
              <Label>Confirmation Code</Label>
              <Input
                label="Confirmation Code"
                name="confirmation_code"
                value={confirmationCode}
                type="text"
                onChange={e =>
                  this.setState({ confirmationCode: e.target.value })
                }
              />
              <Buttons>
                <Button
                  width={100}
                  onClick={onCancel}
                  color="gray"
                  disabled={isConfirmLoading}
                >
                  Cancel
                </Button>

                <Button
                  width={100}
                  onClick={this.onRegistration}
                  loading={isConfirmLoading}
                  disabled={isConfirmLoading}
                >
                  Registration
                </Button>
              </Buttons>
            </Wrapper>
          )}
        </Modal>
      );
    }

    onRegistration = e => {
      e.preventDefault();
      const {
        phoneNumber,
        country,
        provider,
        confirmationCode,
        onRegistration,
        name
      } = this.state;

      let findByCompany = whatsappRegistrationList.find(function(item) {
        return item.country === country;
      });

      let findByProvider = findByCompany.listProvider.find(function(item) {
        return item.provider === provider;
      });

      let mcc = findByCompany.mcc;
      let mnc = findByProvider.mnc;
      let cc = findByCompany.cc;

      this.setState({
        onRegistration: false
      });

      onRegistration
        ? this.registration(phoneNumber, mcc, mnc, cc)
        : this.confirmationCode(phoneNumber, confirmationCode, name, cc);
    };

    registration = async (phoneNumber, mcc, mnc, cc) => {
      // try {
      this.props
        .whatsappRegistration({
          variables: {
            phoneNumber: phoneNumber,
            mcc: parseInt(mcc),
            mnc: parseInt(mnc),
            cc: parseInt(cc)
          }
        })
        .then(res => {
          let message = res.data.whatsappRegistration.message;
          let status = res.data.whatsappRegistration.status;
          if (message == "success") {
            this.setState({ onRegistration: false });
            ShowNotice("whatsapp-registration");
          } else {
            this.setState({ onRegistration: true });
            ShowNotice("whatsapp-registration-error");
          }
        });
      // } catch (error) {
      //   ShowNotice("whatsapp-registration-error");
      // }
    };

    confirmationCode = async (phoneNumber, code, channelName, cc) => {
      // try {
      this.props
        .whatsappConfirmationCode({
          variables: {
            phoneNumber: phoneNumber,
            code: code,
            channelName: channelName,
            cc: parseInt(cc)
          }
        })
        .then(res => {
          let message = res.data.whatsappCodeConfirmation.message;
          let status = res.data.whatsappCodeConfirmation.status;
          if (message == "success") {
            ShowNotice("whatsapp-registration-code");
            this.setState({ onRegistration: false });
            window.location.reload();
          } else {
            ShowNotice("whatsapp-registration-code-error");
          }
        });
    };
  }
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
`;
const Text = styled.div`
  color: ${props => props.theme.uiText};
  font-size: 1rem;
  text-align: center;
  margin-bottom: 10px;
`;
const Label = styled.div`
  color: ${props => props.theme.uiText};
  font-size: 0.8rem;
  margin-top: 10px;
  margin-left: 2px;
`;
const Buttons = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-content: center;
  padding-left: 40px;
  padding-right: 40px;
  /* & > *:first-child {
    margin-right: 20px;
  } */
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/channel-panel/WhatsappModalWithMutation.js